import deepmerge from 'deepmerge';

export const defaultDisabled = {
  regular: {
    cursor: 'not-allowed',
    opacity: 0.4
  }
};

const createGetDisabled = (options: any) => (variant = 'regular') => options[variant];

export const createDisabled = (palette: any, disabled = {}) => {
  const { getDisabled: otherGetDisabled, ...otherOptions }
      = typeof disabled == 'function' ? disabled(palette) : disabled;
  const mergedOptions = deepmerge(defaultDisabled, otherOptions, {
    clone: false
  });
  return {
    getDisabled: otherGetDisabled || createGetDisabled(mergedOptions),
    ...mergedOptions
  }
};
